import React, { useEffect, useState } from "react";
import Headers from "../Common/Headers";
import "./style.css";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getAPIUrlBM } from "../../../utils/config";
import Post from "../../../Apis/backlink/Post";
import Get from "../../../Apis/backlink/Get";
import LinkTable from "../../utils/LinkTable/LinkTable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import favicon from "../Assets/Favicon.png";
import loadingGif from "../Assets/loading.gif";
import TablePagination from "../../utils/TablePagination/TablePagination";
import Filter from "./Filter";
import DeleteIcon from "../Assets/DeleteIcon";
import papa from "papaparse";
import RouteChecker from "../../utils/RouteChecker";
import KeyboardArrowDownIcon from "../Assets/KeyboardArrowDownIcon";
import KeyboardArrowUpIcon from "../Assets/KeyboardArrowUpIcon";

function Links() {
  // use query params
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramFilter = queryParams.get("filter");

  const [searched, setSearched] = useState(null);
  const [isloading, setIsloading] = useState(true);
  const [links, setLinks] = useState();
  const [reasonOfErrorFilter, setReasonOfErrorFilter] = useState([
    { name: "Page 4XX", value: "Page 4" },
    { name: "Page 5XX", value: "Page 5" },
    { name: "Anchor text almost matched", value: "Anchor text almost matched" },
    { name: "Rel tag not matched", value: "Rel tag not matched" },
    { name: "Anchor text not matched", value: "Anchor text not matched" },
    { name: "Reltag found", value: "Reltag found" },
    { name: "Anchor text found", value: "Anchor text found" },
    {
      name: "Domain present, exact link not found",
      value: "Domain present, exact link not found",
    },
    { name: "link_to not in link_from", value: "link_to not in link_from" },
    {
      name: "Internal error. Note able to render site.",
      value: "Internal error. Note able to render site.",
    },
    { name: "Link Timeout", value: "Link Timeout" },
    { name: "link_from invalid", value: "link_from invalid" },
  ]);
  const navigate = useNavigate();
  const params = useParams();
  const [listId, setListId] = useState(
    params.listId !== undefined ? params.listId : "",
  );

  const [lists, setLists] = useState();
  const [deleteAll, setDeleteAll] = useState([]);
  const [statusArray, setStatusArray] = useState(
    paramFilter ? [paramFilter] : [],
  );
  const [reasonOfErrorArray, setReasonOfErrorArray] = useState([]);
  const [expandAll, setExpandAll] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("rowsPerPageInLink") || 50,
  );
  const [filter, setFilter] = useState({
    createDate: null,
    linkFrom: null,
    linkTo: null,
    listIncluded: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);

  const handleStatus = async (operation, value) => {
    console.log(operation);
    setCurrentPage(1);
    if (operation) setStatusArray([...statusArray, value]);
    else {
      var newStatusArr = statusArray.filter((val) => val != value);
      setStatusArray(newStatusArr);
    }
  };
  const handleReasonForError = async (operation, value) => {
    setCurrentPage(1);
    if (operation) setReasonOfErrorArray([...reasonOfErrorArray, value]);
    else {
      var newReasonOfErrorArray = reasonOfErrorArray.filter(
        (val) => val != value,
      );
      setReasonOfErrorArray(newReasonOfErrorArray);
    }
  };
  const DeleteAll = async () => {
    const url = getAPIUrlBM();
    // console.log(listId, "This is list id");
    window
      .sweet({
        title: "Are you sure ?",
        text: "Once deleted, you will not be able to recover this links!",
        icon: "warning",
        buttons: true,
      })
      .then(async (confirm) => {
        if (!confirm) {
          window.sweet({
            title: "Your links are safe!",
            icon: "success",
          });
          return;
        }

        const listID =
          listId !== "all" && listId !== undefined && listId !== ""
            ? listId
            : undefined;
        console.log(listID, "This is list id");
        const res = await Post(url + "/deleteAllLink", {
          listId: listID,
          search: searched !== "" ? searched : undefined,
          deleteAll: deleteAll,
        });
        if (res.message === "Delete Link Successfully") {
          // getLinks(listId);
          window.sweet({
            title: "Deleted!",
            text: "Your links has been deleted.",
            icon: "success",
          });
          setLinks([]);
          const url = getAPIUrlBM();
          var listId = listID !== "all" ? listID : "";
          // console.log(filter, "This filter is going");
          const reqBody = {
            ...filter,
            search: searched ? searched : "",
          };
          if (listId !== "") reqBody.listId = listId;
          if (statusArray.length !== 0) reqBody.status = statusArray;
          if (reasonOfErrorArray.length !== 0)
            reqBody.reasonForerror = reasonOfErrorArray;

          const res = await Post(
            url + `/getpaginatelinks?page=${1}&size=${rowsPerPage}`,
            reqBody,
          );
          setLinks((prev) => res.data2);
          if (currentPage === 1) setTotalRows(parseInt(res.count));

          setDeleteAll([]);
          document.getElementById("bulkCheckBox").checked = false;
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // if (res.status === 200) {
    //   setLinks([]);
    // }
  };
  const requestSearch = async () => {
    try {
      // setIsloading(true);
      const url = getAPIUrlBM();
      const curListId = listId !== "all" ? listId : "";
      const res = await Post(
        url + `/searchlink?page=${currentPage}&size=${rowsPerPage}`,
        {
          search: searched,
          listId: curListId,
        },
      );
      setTotalRows(parseInt(res.metaData));
      setLinks(res.data);
      // setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const header = {
    heading: "Links",
    link: "https://app.supademo.com/demo/clqfbxauw3pngpetz01uhg8nq",
    subHeading: "Check your backlinks",
    description:
      "Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively.",
    isSubHeading: true,
  };

  const getLinks = async (id) => {
    try {
      const url = getAPIUrlBM();
      var listId = id !== "all" ? id : "";
      console.log(filter, "This filter is going");
      const reqBody = {
        ...filter,
        search: searched ? searched : "",
      };
      if (listId !== "") reqBody.listId = listId;
      if (statusArray.length !== 0) reqBody.status = statusArray;
      if (reasonOfErrorArray.length !== 0)
        reqBody.reasonForerror = reasonOfErrorArray;

      const res = await Post(
        url + `/getpaginatelinks?page=${currentPage}&size=${rowsPerPage}`,
        reqBody,
      );
      const resData = await res.data2;
      setLinks((prev) => resData);
      console.log(statusArray, resData);
      if (currentPage === 1) setTotalRows(parseInt(res.count));
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getLists = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getlistname");
      setLists(res.response);
    } catch (error) {
      console.log(error);
    }
  };
  // const getReasonOfErrors = async () => {
  //   const url = getAPIUrlBM();
  //   const res = await Get(url + "/getreasonoferrors");
  //   setReasonOfErrorFilter(res.data);
  // };
  useEffect(() => {
    getLists();
  }, []);
  useEffect(() => {
    getLinks(listId);
    // localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("rowsPerPageInLink", rowsPerPage);
  }, [
    rowsPerPage,
    currentPage,
    filter,
    statusArray,
    reasonOfErrorArray,
    listId,
  ]);

  // useEffect(() => {
  //   // // getReasonOfErrors();
  //   // getLinks(listId);
  //   // set to page 1 for every filter added

  // }, [statusArray, reasonOfErrorArray, listId]);

  const deleteLinkItem = (listID, linkID) => {
    setLinks(
      links.filter((link) => {
        return !(link.link_id === linkID && link.list_id === listID);
      }),
    );
  };

  const generateCsvData = (data) => {
    const Data = data.filter((item) => {
      return deleteAll.includes(item.link_id);
    });
    const structData = Data.map((item) => {
      return {
        "Link Id": `'${item.link_id}'`,
        "List Id": `'${item.list_id}'`,
        "Link From": item.link_from,
        "Link To": item.link_to,
        "Anchor Text": item.anchor,
        "Rel tag": item.rel_tag,
        "Link Status": item.status,
        "Link Notes": item.linkNotes,
        "Link Index Status": item.index_status,
        "Link Send For Indexing": item.send_for_indexing ? "Yes" : "No",
        "Spam Rating": item.spam_rating,
        "Link Check For Index": item.check_index ? "Yes" : "No",
        "Link Created At": new Date(item.create_date)
          .toLocaleDateString()
          .toString(),
      };
    });

    const csv = papa.unparse(structData);
    // console.log(csv, deleteAll, "csv");
    return csv;
  };

  const handleDownload = () => {
    const csvData = generateCsvData(links);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element and click it to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "data.csv";
    a.click();

    // Cleanup by revoking the object URL
    URL.revokeObjectURL(url);
  };
  // console.log(links, "Outside filter");

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>Links - Backlink Checker</title>
        <meta
          name="description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}

        {/* <meta
          property="og:image"
          key="og:image"
          content={
            "http://localhost:3000" +
            window.location.pathname +
            "/og_backLink.jpg"
          }
        /> */}
        {/* <meta property="og:image" key="og:image" content={ogImage} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta property="og:title" content="Links - Backlink Checker" />
        <meta
          property="og:description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
      </Helmet>
      <RouteChecker url="linkScreen">
        {!isloading ? (
          <>
            <div className="subMainContainer">
              <Headers header={header} />

              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "blue",
                  marginBottom: "1rem",
                  cursor: "pointer",
                }}
                onClick={() => {
                  window.open(
                    "https://backlinkchecker.tawk.help/article/what-are-the-different-errors-statuses-of-links",
                    "_blank",
                  );
                }}
              >
                What do the Status & Error Code mean?
              </span>
              <div className="linkBody">
                <div>
                  <p className="heading">Filter & Search BackLink</p>
                  <div className="linkFilterSection">
                    <div className="filterItem1">
                      <p className="subHeader"> Search a List</p>
                      <select
                        name="curList"
                        value={listId}
                        onChange={(e) => {
                          setListId(e.target.value);
                          if (e.target.value === "") getLinks();
                        }}
                      >
                        <option value="all">All</option>
                        {lists?.map((list, index) => (
                          <option value={list.list_id} key={index}>
                            {list.list_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="filterItem2">
                      <p className="subHeader">Status</p>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              defaultChecked={paramFilter === "Ok"}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Ok")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Ok</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              defaultChecked={paramFilter === "Present"}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Present")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Present</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              defaultChecked={paramFilter === "Not Checked"}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Not Checked")
                              }
                            />
                          }
                          label={
                            <span className="labelCheckbox">Not checked</span>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              defaultChecked={paramFilter === "Absent"}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Absent")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Absent</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              defaultChecked={paramFilter === "Error"}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Error")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Error</span>}
                        />
                      </FormGroup>
                    </div>

                    <div className="filterItem3">
                      <p className="subHeader">Reason of error</p>
                      <FormGroup>
                        <div className="grid_Filters">
                          {reasonOfErrorFilter?.map((errType, index) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="success"
                                  onChange={(e) =>
                                    handleReasonForError(
                                      e.target.checked,
                                      errType.value,
                                    )
                                  }
                                />
                              }
                              label={
                                <span className="labelCheckbox">
                                  {errType.name}
                                </span>
                              }
                            />
                          ))}
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <div>
                    <p className="subHeader"> Search</p>
                    <input
                      type="text"
                      value={searched}
                      placeholder="Search a specific item - ‘Link From’ or ‘Link To’ URL"
                      className="searchField"
                      onChange={(e) => setSearched(e.target.value)}
                    />
                    <button
                      onClick={() => {
                        if (currentPage === 1) getLinks(listId);
                        else setCurrentPage(1);
                      }}
                      className="successButton"
                    >
                      Search
                    </button>

                    <div className="delete_container">
                      <div className="delete_container_2 mr-3">
                        <input
                          id={"bulkCheckBox"}
                          type={"checkbox"}
                          onClick={(e) => {
                            // console.log(document.getElementById("deleteAll"));
                            if (e.target.checked) {
                              setDeleteAll((prev) =>
                                links?.map((link) => link.link_id),
                              );
                              // setDeleteAll(true);
                            } else {
                              setDeleteAll([]);
                            }
                          }}
                        />
                        <span
                          style={{
                            "font-size": "1rem",
                            "font-weight": "bold",
                            color: "grey",
                          }}
                        >
                          Select All
                        </span>
                      </div>
                      <span className="ml-2 mr-2">Bulk Actions:</span>
                      <div className="delete_container_1" style={{}}>
                        {true ? (
                          <div
                            style={{
                              backgroundColor:
                                deleteAll.length > 0 ? "" : "#ebf4f5",
                              color: deleteAll.length > 0 ? "red" : "#b5c6e0",
                              borderColor:
                                deleteAll.length > 0 ? "red " : "grey",
                            }}
                            className="deleteAll mr-5"
                            onClick={
                              deleteAll.length > 0 ? DeleteAll : () => {}
                            }
                          >
                            <span>Delete All Selection</span>
                            <DeleteIcon
                              color={deleteAll.length > 0 ? "red" : "grey"}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="delete_container_csv">
                        {true ? (
                          <div
                            style={{
                              backgroundColor:
                                deleteAll.length > 0 ? "" : "#ebf4f5",
                              color: deleteAll.length > 0 ? "green" : "#b5c6e0",
                              borderColor:
                                deleteAll.length > 0 ? "green" : "grey",
                            }}
                            className="deleteAll mr-5"
                            onClick={
                              deleteAll.length > 0 ? handleDownload : () => {}
                            }
                          >
                            <span>Download Links in CSV</span>
                            <img
                              width={20}
                              height={20}
                              alt="download"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADWklEQVR4nO2X/U+SURTH+a1/oa1/pF9aW5Py99YP4qYrKG1mW+Wy1Mmsli/Zi2ZaaYrio5YrDcvXlFUCDzVfM3SJlKmgmMlTirwIp92jMHEUiD4XTM52xnPuuVzOh/s99+4RCKIWNX6NNWqBH2fzdi1A32wfPQiWB4AFq5EeBMsDAGebowfB8gRADYL1UwCjq/frweY9ABwNCL4BOL4h+JQQRwOCFgDHFwQNCXF8QtAG4DZB8AJA0wV7HiCh4jKE0wXbtT0NIK7KgFNVGZEH8KCHAaPFDM5VJxgXzVCjbvbJS5uL4ev8NLjBDS63Cz4YhuGsXIo5tX4AlmxWaPzY7p1f2sPg2IT5O/8Aea2PsLBluxU+z+hhxWEHYgVtFZg/LcsCi/U3jmkmBrEoYqrxfsxXq5owHpn54l2zZ5TFsY6R9/wDaA1D+GP5reUYlynr14rVD2CcoyjB2DA/hXFKbQ7GKw4bxpee5nnjk5VXcGzqpwnHbrVX8A8w+WMGf0wiy8T4QsNNeDWkBFnvC2/sdrvB5rTDnc4qv7omsiOW3VSE0vLMJz3DO8DiMocS+lfjESCPEZndaCn1ybd/eoc5ufol3O6oxOeBSR2dJg4GgHhRV7V3t0gjl3TXenMFbeU4zk4MgmKwG59lqrUdpCYhz3afY65BZe9zuNspw5hIguicfCY+SQdGo8D5Jsu8dw1ytBLJLCxZYMxkwPzFhlw6AJ4mzmq6h/H9brnPKVO7XrBylMU4uUaKMSl44zr9kzocX3W5YHpxlt49kPt67Rg1/1qA3vE+4NaPTCILkif/pN3pAMeqE97o1N5CdUa9zzpEMh5rHX5L9yIjeiYnCSmSHIFlyrpNd8VjlIzHxue+QdqzfJ85BNRj5G6hChCspzLXIak6e8vfE4okfp06QKgujAJssHC8hQl3cgf+SwBmmy/1gfLCKMD/LiF2twMwO9gDKYXSvxYcyGNEkodhB5CP1EF8elooAOrY2NR9ESGhrjElHE8+v5XiTUcSkg6ELCE+vFHTArEJSYGLjxM7jsVLDgVVPE0A1qiFMoU8IMBRkeRM0MXTBmCNWrhaXLi9pg03gGpKA5LMrNCbNhLs8InE/cI48XRITRspFhMvORgjEtu23LSRZKRhAzXtH8TEVoEYhfoOAAAAAElFTkSuQmCC"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="linkTable px-2">
                  <div className="gridContainerInTable">
                    <div className="gridItemInTable gridItemInTableHeader">
                      Bulk
                    </div>{" "}
                    <div className="gridItemInTable gridItemInTableHeader">
                      LinkID
                    </div>
                    <div
                      className="gridItemInTable gridItemInTableHeader d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (filter.createDate === 1)
                          setFilter((prev) => ({
                            ...prev,

                            linkTo: null,
                            listIncluded: null,
                            linkFrom: null,
                            createDate: 2,
                          }));
                        else if (filter.createDate === 2)
                          setFilter((prev) => ({
                            ...prev,
                            linkTo: null,
                            listIncluded: null,
                            linkFrom: null,
                            createDate: null,
                          }));
                        else
                          setFilter((prev) => ({
                            ...prev,
                            linkTo: null,
                            listIncluded: null,
                            linkFrom: null,
                            createDate: 1,
                          }));
                      }}
                    >
                      <span className="mr-2">Added On</span>
                      <Filter
                        setSort={setFilter}
                        sort={filter.createDate}
                        keys={"createDate"}
                        // onChange={() => {
                        //   setLinks([]);
                        //   getLinks();
                        // }}
                      />
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Index Status
                    </div>
                    <div
                      className="gridItemInTable gridItemInTableHeader d-flex align-items-center "
                      onClick={() => {
                        if (filter.linkFrom === 1)
                          setFilter((prev) => ({
                            ...prev,
                            linkFrom: 2,
                            linkTo: null,
                            listIncluded: null,
                            createDate: null,
                          }));
                        else if (filter.linkFrom === 2)
                          setFilter((prev) => ({
                            ...prev,
                            linkFrom: null,
                            linkTo: null,
                            listIncluded: null,
                            createDate: null,
                          }));
                        else
                          setFilter((prev) => ({
                            linkFrom: 1,
                            linkTo: null,
                            listIncluded: null,
                            createDate: null,
                          }));
                      }}
                    >
                      <span className="mr-2">Link From Page</span>
                      <Filter
                        setSort={setFilter}
                        sort={filter.linkFrom}
                        keys={"linkFrom"}
                        // onChange={() => {
                        //   setLinks([]);
                        //   getLinks();
                        // }}
                      />
                    </div>
                    <div
                      className="gridItemInTable gridItemInTableHeader d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (filter.linkTo === 1)
                          setFilter((prev) => ({
                            linkFrom: null,
                            linkTo: 2,
                            listIncluded: null,
                            createDate: null,
                          }));
                        else if (filter.linkTo === 2)
                          setFilter((prev) => ({
                            linkFrom: null,
                            linkTo: null,
                            listIncluded: null,
                            createDate: null,
                          }));
                        else
                          setFilter((prev) => ({
                            linkFrom: null,
                            linkTo: 1,
                            listIncluded: null,
                            createDate: null,
                          }));
                      }}
                    >
                      <span className="mr-2">Link To URL</span>

                      <Filter
                        setSort={setFilter}
                        sort={filter.linkTo}
                        keys={"linkTo"}
                        // onChange={() => {
                        //   setLinks([]);
                        //   getLinks();
                        // }}
                      />
                    </div>
                    <div
                      className="gridItemInTable gridItemInTableHeader d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (filter.listIncluded === 1)
                          setFilter(() => ({
                            linkTo: null,
                            linkFrom: null,
                            createDate: null,
                            listIncluded: 2,
                          }));
                        else if (filter.listIncluded === 2)
                          setFilter((prev) => ({
                            linkTo: null,
                            linkFrom: null,
                            createDate: null,
                            listIncluded: null,
                          }));
                        else
                          setFilter((prev) => ({
                            linkTo: null,
                            linkFrom: null,
                            createDate: null,
                            listIncluded: 1,
                          }));
                      }}
                    >
                      <span className="mr-2">List Included In</span>
                      <Filter
                        setSort={setFilter}
                        sort={filter.listIncluded}
                        keys={"listIncluded"}
                        // onChange={() => {
                        //   setLinks([]);
                        //   getLinks();
                        // }}
                      />
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Rel Tag
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Anchor
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Notes
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Error Code
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      DA
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Spam Score
                    </div>
                    <div className="gridItemInTable gridItemInTableHeader">
                      Status
                      <br />
                      <div onClick={() => setExpandAll(!expandAll)}>
                        <span
                          style={{
                            marginRight: "5px",
                            color: "#5541D7",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                        >
                          {expandAll ? "Collapse All Logs" : "Expand All Logs"}
                        </span>
                        {!expandAll && <KeyboardArrowDownIcon />}
                        {expandAll && <KeyboardArrowUpIcon />}
                      </div>
                    </div>
                  </div>
                  {links?.length !== 0 ? (
                    links?.map((link, index) => {
                      return (
                        <LinkTable
                          deleteAll={deleteAll}
                          setDeleteAll={setDeleteAll}
                          key={link.link_id + index}
                          data={{
                            ...link,
                            link_to: link?.link_to
                              .replace("https://", "")
                              .replace("http://", ""),
                            link_from: link?.link_from
                              .replace("https://", "")
                              .replace("http://", ""),
                          }}
                          id={link?.link_id}
                          open={index === 0}
                          deleteLinkItem={deleteLinkItem}
                          showDelete={true}
                          expandAll={expandAll}
                        />
                      );
                    })
                  ) : links?.length === 0 &&
                    statusArray.length === 0 &&
                    reasonOfErrorArray.length === 0 &&
                    searched === null ? (
                    <>
                      <div
                        style={{
                          gridColumn: "1/9",
                        }}
                      >
                        <div className="centerDiv">
                          <p className="noData">List is empty</p>
                          <button
                            onClick={() => navigate("/backlink/link/add")}
                            className={"submitButton"}
                          >
                            Add Backlink
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        gridColumn: "1/9",
                      }}
                    >
                      <div className="centerDiv">
                        <p className="noData">No result found!!</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <TablePagination
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRows={totalRows}
            />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
              margin: "-15px -30px",
            }}
          >
            <img
              style={{
                width: "82vw",
                height: "94vh",
              }}
              alt=""
              src={loadingGif}
            />
          </div>
        )}
      </RouteChecker>
    </div>
  );
}

export default Links;
